/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithSessionCt
 */
export interface WithSessionCtOptional {
  /**
   *
   * @type {number}
   * @memberof WithSessionCt
   */
  sessionCt?: number;
}

export interface WithSessionCt extends WithSessionCtOptional {
  /**
   *
   * @type {number}
   * @memberof WithSessionCt
   */
  sessionCt?: number;
}

export interface WithSessionCtTrackedI {
  /**
   *
   * @type {number}
   * @memberof WithSessionCt
   */
  sessionCt?: number;
  sessionCtIsSet: boolean;
}

transformDatesMap.set("WithSessionCt", function (model: WithSessionCt) {});

export type WithSessionCtMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  sessionCt: PropertyMeta<MetaTypeBase<number>>;
}>;

export var WithSessionCtMeta: WithSessionCtMetaI = {} as WithSessionCtMetaI;
WithSessionCtMeta = typeMeta("WithSessionCt", {
  sessionCt: propertyMeta(
    "sessionCt",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = WithSessionCtMeta;

registerMeta(() => {});

export class WithSessionCtTracked implements WithSessionCtTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  sessionCt__I?: number = undefined;
  sessionCtIsSet: boolean = false;
  set sessionCt(v: undefined | number) {
    if (v !== undefined) {
      this.sessionCt__I = v;
      this.sessionCtIsSet = true;
    } else {
      this.sessionCt__I = v || undefined;
      this.sessionCtIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionCt() {
    return this.sessionCt__I;
  }
  constructor(config?: WithSessionCtOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithSessionCtOptional,
    options?: AssignOptions,
  ): WithSessionCtTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.sessionCt && this.sessionCtApplyFilter(optionsRequired.filter)) {
      this.sessionCt = config.sessionCt;
      if (optionsRequired.unassign) this.sessionCtIsSet = false;
      else this.sessionCtIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithSessionCtTrackedI {
    const cloned = {} as WithSessionCtTrackedI;
    if (
      this.sessionCtIsSetDeep() &&
      this.sessionCtApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionCtIsSet = true;
      cloned.sessionCt = this.sessionCt;
    } else {
      //cloned.sessionCtIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithSessionCtTrackedI {
    if (!this.sessionCtApplyFilter(filter)) this.sessionCtIsSet = false;

    return this;
  }
  sessionCtApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithSessionCtMeta.sessionCt,
      WithSessionCtMeta,
      this.sessionCt,
      this,
    );
  }
  sessionCtIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionCtIsSet && this.sessionCtApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.sessionCtIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
